import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import { Message, Label } from 'oxyrion-ui/lib';

import LabeledRadio from 'oxyrion-ui/lib/LabeledRadio';
import { ErrorWrapper } from '../../Components/ReusableComponents';
import ProductQuantitySelectPropsValue from '../../Components/ProductQuantitySelectPropsValue';

import { __ } from '../../Utils';

const Wrapper = styled.div`
  font-size: ${rem(14)};
  display: flex;
  flex-direction: column;
  @media (min-width: 1900px) {
    flex-direction: row;
  }
`;

const SubWrapper = styled.div`
  display: flex;
  width: 100%;
  @media (min-width: 1900px) {
    width: auto;
  }
  justify-content: space-between;
  margin-bottom: ${rem(24)};
`;

const SearchableSelectWrapper = styled.div``;

const RadiosWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const RadioWrapper = styled.div`
  margin-right: ${rem(16)};
`;

const ComplementarsWrapper = styled.div``;

const StockQuantityWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  margin-right: 36px;

  .quantity {
  }

  .label {
    font-weight: bold;
    margin-right: 4px;
  }
`;

class ThirdStep extends React.Component {
  state = {
    error: false,
  };

  render() {
    const { error } = this.state;
    const {
      variants,
      handleComplementarChange,
      handleQuantityChange,
      handleVariantChange,
      selectedVariant,
      selectedComplementar,
      handleComplementarQuantityChange,
      quantity,
      complementarQuantity,
    } = this.props;

    if (error) {
      return (
        <ErrorWrapper>
          <Message error message={error} />
        </ErrorWrapper>
      );
    }
    if (!selectedVariant) {
      return <div />;
    }
    return (
      <Wrapper>
        <SubWrapper>
          <SearchableSelectWrapper>
            <Label>{__('Plnenie / Balenie')}</Label>
            <RadiosWrapper>
              {variants.map(v => (
                <RadioWrapper>
                  <LabeledRadio
                    value={v.volume}
                    labelText={`${v.volume} ${
                      v.volume.includes('L') ? '' : 'l'
                    } / ${v.filling} ${v.filling.includes('L') ? '' : 'l'} ${
                      v.finished_effect ? ` - ${v.finished_effect}` : ''
                    }`}
                    onChange={() => handleVariantChange(v._id)}
                    checked={selectedVariant && selectedVariant._id === v._id}
                  />
                </RadioWrapper>
              ))}
            </RadiosWrapper>
          </SearchableSelectWrapper>
          {/* <SearchableSelectWrapper>
            <SearchableSelectWrapper>
              <Label>{__('Balenie')}</Label>
              <RadiosWrapper>
                {variants.map(v => (
                  <RadioWrapper>
                    <LabeledRadio
                      value={v.volume}
                      labelText={`${v.filling} ${
                        v.filling.includes('L') ? '' : 'l'
                      }`}
                      onChange={() => handleVariantChange(v._id)}
                      checked={selectedVariant && selectedVariant._id === v._id}
                    />
                  </RadioWrapper>
                ))}
              </RadiosWrapper>
            </SearchableSelectWrapper>
            <SearchableSelectWrapper>
              <Label>{__('Plnenie')}</Label>
              <RadiosWrapper>
                {variants.map(v => (
                  <RadioWrapper>
                    <LabeledRadio
                      value={v.volume}
                      labelText={`${v.volume} ${
                        v.volume.includes('L') ? '' : 'l'
                      } ${v.finished_effect ? ` - ${v.finished_effect}` : ''}`}
                      onChange={() => handleVariantChange(v._id)}
                      checked={selectedVariant && selectedVariant._id === v._id}
                    />
                  </RadioWrapper>
                ))}
              </RadiosWrapper>
            </SearchableSelectWrapper>
            // ak by nahodou niekedy chceli naspat v 2 riadkoch
          </SearchableSelectWrapper> */}
          {selectedVariant && (
            <div>
              <ProductQuantitySelectPropsValue
                items={selectedVariant.Unit_of_Measure}
                showTitle={false}
                showButton={false}
                changeListener={value => handleQuantityChange(value.pcs)}
                variantId={selectedVariant._id}
                pcs={quantity}
                key="quantity"
              />
              {selectedVariant.on_stock_withou_reserved > 0 && (
                <StockQuantityWrapper>
                  <div className="label">{__('Na sklade')}:</div>
                  <div className="quantiy">
                    {selectedVariant.on_stock_withou_reserved} ks
                  </div>
                </StockQuantityWrapper>
              )}
            </div>
          )}
        </SubWrapper>
        {selectedComplementar && (
          <SubWrapper>
            {selectedVariant &&
              selectedVariant.complementary_products &&
              selectedVariant.complementary_products.map(c => (
                <ComplementarsWrapper>
                  <Label>{__('Tužidlo')}</Label>
                  <RadioWrapper
                    onClick={() =>
                      handleComplementarChange(selectedVariant._id, c._id)
                    }
                  >
                    <LabeledRadio
                      value={c.name}
                      labelText={c.name}
                      checked={
                        selectedComplementar &&
                        selectedComplementar._id === c._id
                      }
                    />
                  </RadioWrapper>
                </ComplementarsWrapper>
              ))}
            <ProductQuantitySelectPropsValue
              items={selectedComplementar.Unit_of_Measure}
              showTitle={false}
              showButton={false}
              pcs={complementarQuantity}
              key="complementarQuantity"
              changeListener={value =>
                handleComplementarQuantityChange(value.pcs)
              }
            />
          </SubWrapper>
        )}
      </Wrapper>
    );
  }
}
ThirdStep.propTypes = {
  history: PropTypes.shape({}).isRequired,
  variants: PropTypes.arrayOf({}),
  handleVariantChange: PropTypes.func,
  handleComplementarChange: PropTypes.func,
  handleQuantityChange: PropTypes.func,
  selectedVariant: PropTypes.shape({
    volume: PropTypes.string,
  }),
  selectedComplementar: PropTypes.shape({}),
  handleComplementarQuantityChange: PropTypes.func,
  quantity: PropTypes.number,
  complementarQuantity: PropTypes.number,
};

ThirdStep.defaultProps = {
  variants: [],
  handleVariantChange: () => {},
  handleComplementarChange: () => {},
  handleQuantityChange: () => {},
  handleComplementarQuantityChange: () => {},
  selectedVariant: null,
  selectedComplementar: null,
  quantity: 0,
  complementarQuantity: 0,
};

export default ThirdStep;



// WEBPACK FOOTER //
// ./src/Containers/Toning/thirdStep.jsx